import { Injectable } from '@angular/core';
import { User_Types } from '@gql/graphql';
import { environment } from '@env';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Roles } from '@core/enums';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UserTypesService {
  private disabledUserRoles: string[] = [Roles.admin];
  private selectedRole: number;

  get getSelectedRole(): number {
    return this.selectedRole;
  }

  set setSelectedRole(role: number) {
    this.selectedRole = role;
  }
  constructor(private http: HttpClient) {}

  private updateUserRolesDisabledProps(
    e: (User_Types & { disabled?: true })[]
  ): any {
    this.disabledUserRoles.map((role) => {
      const index = e.findIndex((r) => r.user_type_name === role);
      const idx = e[index];
      if (idx?.disabled) {
        idx.disabled = true;
      }
    });
  }

  getUserTypes(): Observable<(User_Types & { disabled?: true })[]> {
    const url = 'auth/user-types';
    return this.http
      .get<(User_Types & { disabled?: true })[]>(
        `${environment.restApiUrl}${url}`
      )
      .pipe(
        map((e) => {
          this.updateUserRolesDisabledProps(e);
          return e;
        })
      );
  }
}
